import { Button, ButtonGroup, CardBody, CardTitle } from "reactstrap";
import "./SongsheetCarousel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faCog,
  faFile,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import { ToggleButton } from "../common/ToggleButton";
import { useTranslation } from "react-i18next";

interface Props {
  showBanner: boolean;
  setShowBanner: (visible: boolean) => void;
  isBeamerModeActive: boolean;
  openBeamerWindow: () => void;
  amountOfPagesInSongsheetCarousel: number;
  setAmountOfPagesInSongsheetCarousel: (amount: number) => void;
}

export default function CarouselSettingsSidebar(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      <CardBody>
        <CardTitle>
          <FontAwesomeIcon icon={faCog} className="me-1" />{" "}
          {t("carousel.settings.general")}
        </CardTitle>
        <ToggleButton
          value={t("carousel.settings.showPlaylist")}
          setIsActive={props.setShowBanner}
          isActive={props.showBanner}
          color="primary"
          outline
        />
      </CardBody>
      {props.isBeamerModeActive ? (
        <CardBody>
          <CardTitle>
            <FontAwesomeIcon icon={faVideo} className="me-1" />
            {t("carousel.settings.beamLyrics")}
          </CardTitle>
          {t("carousel.settings.beamInstructions")}
          <br />
          <br />
          <Button
            color="primary"
            outline
            onClick={() => props.openBeamerWindow()}
          >
            <FontAwesomeIcon icon={faVideo} className="me-1" />
            {t("carousel.settings.openBeamer")}
          </Button>
        </CardBody>
      ) : (
        <CardBody>
          <CardTitle>
            <FontAwesomeIcon icon={faBookOpen} className="me-1" />
            {t("carousel.settings.showSongsheets")}
          </CardTitle>
          <p>{t("carousel.settings.songsheetsInstructions")}</p>
          <ButtonGroup>
            <Button
              color="primary"
              outline
              onClick={() => props.setAmountOfPagesInSongsheetCarousel(1)}
              active={props.amountOfPagesInSongsheetCarousel === 1}
            >
              <FontAwesomeIcon icon={faFile} className="me-1" />
              {t("carousel.settings.singlePage")}
            </Button>
            <Button
              color="primary"
              outline
              onClick={() => props.setAmountOfPagesInSongsheetCarousel(2)}
              active={props.amountOfPagesInSongsheetCarousel === 2}
            >
              <FontAwesomeIcon icon={faBookOpen} className="me-1" />
              {t("carousel.settings.doublePage")}
            </Button>
          </ButtonGroup>
        </CardBody>
      )}
    </>
  );
}
